import React from "react";

function PaymentSummary() {
  return <div>Payment Summary</div>;
}

export default PaymentSummary;
